var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "oc-dropdown-store dropdown only-click",
      class: { open: _vm.toggle }
    },
    [
      _c(
        "span",
        {
          staticClass: "oc-dropdown-store__box oc-clickable",
          on: {
            click: function($event) {
              ;(_vm.toggle = !_vm.toggle), (_vm.cl = true)
            }
          }
        },
        [_vm._v(_vm._s(_vm.text))]
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "oc-dropdown-store__menu dropdown-menu scroll" },
        [
          _c("li", [
            _c("a", [
              _c("div", { staticClass: "checkbox" }, [
                _c(
                  "label",
                  [
                    _c("checkbox", {
                      attrs: { checked: _vm.value.indexOf("general") != -1 },
                      on: {
                        change: function(val) {
                          _vm.toggleDomain(val, "general")
                        }
                      }
                    }),
                    _vm._v(
                      "\n                        Все домены\n                    "
                    )
                  ],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.domains, function(domain, index) {
            return _c("li", { key: index }, [
              _c("a", [
                _c("div", { staticClass: "checkbox" }, [
                  _c(
                    "label",
                    [
                      _c("checkbox", {
                        attrs: { checked: _vm.value.indexOf(domain) != -1 },
                        on: {
                          change: function(val) {
                            _vm.toggleDomain(val, domain)
                          }
                        }
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(domain) +
                          "\n                    "
                      )
                    ],
                    1
                  )
                ])
              ])
            ])
          })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-580d14f7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-580d14f7","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/webpack/vue/settings/components/notification/DropdownStore.vue
// module id = 142
// module chunks = 0